<nav class="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
  id="layout-navbar">
  <div class="layout-menu-toggle navbar-nav align-items-xl-center me-2 me-sm-3 me-xl-0 d-xl-none">
    <a class="nav-item nav-link px-0 me-xl-4" href="javascript:void(0)">
      <i class="ti ti-menu-2 ti-sm"></i>
    </a>
  </div>

  <!-- Faixa do grupo: empresa ativa e troca de empresa. Sem o logo do MarketConnector em nenhuma
       largura: o cabeçalho é da empresa (o logo do produto fica no menu lateral). -->
  <div class="navbar-brand-band" [class.navbar-brand-band--group]="hasGroupBrand()">
    <app-company-select></app-company-select>
  </div>

  <div class="navbar-nav-right d-flex align-items-center" id="navbar-collapse">

    <!-- Search bar -->
    <div class="navbar-nav align-items-center">
      <div class="nav-item navbar-search-wrapper mb-0">
        <!-- Tablet/desktop: barra com o texto do que dá para buscar e o atalho; celular: só a lupa. -->
        <button id="navbar-search-trigger"
          class="nav-item nav-link search-toggler navbar-search-bar d-flex align-items-center px-0 border-0 bg-transparent"
          (click)="openSearch()" aria-label="Abrir busca (CTRL+K)">
          <i class="ti ti-search ti-sm me-0 me-sm-2 text-muted"></i>
          <span class="text-muted fw-normal d-none d-sm-inline d-md-none">Buscar</span>
          <span class="search-bar-text d-none d-md-inline">Buscar pedido, produto, nota ou página</span>
          <span class="search-bar-kbd d-none d-md-inline">Ctrl K</span>
        </button>
      </div>
    </div>

    <!-- Right icons -->
    <ul class="navbar-nav flex-row align-items-center ms-auto">

      <!-- Alertas de integração (SignalR): SÓ falha que pede ação — ERP recusou pedido/NF/liquidação.
           Recebimento e sucesso não entram: viravam ruído e escondiam a falha. -->
      <li class="nav-item navbar-dropdown dropdown mx-1" ngbDropdown (openChange)="onActivityOpenChange($event)">
        <a id="navbar-activity" class="nav-link hide-arrow p-0 position-relative" href="javascript:void(0);"
          ngbDropdownToggle aria-label="Alertas de integração">
          <i class="ti ti-bell fs-large cursor-pointer text-muted"></i>
          @if (activity.unread() > 0) {
            <span class="activity-unread">{{ activity.unread() > 9 ? '9+' : activity.unread() }}</span>
          }
        </a>
        <div class="dropdown-menu dropdown-menu-end activity-panel p-0" ngbDropdownMenu>
          <div class="d-flex align-items-center justify-content-between px-3 py-2 border-bottom">
            <span class="fw-semibold">Alertas de integração</span>
            <span class="activity-status" [class.activity-status--on]="activity.connected()"
              [ngbTooltip]="activity.connected() ? 'Novas falhas aparecem em tempo real.' : 'Novas falhas aparecem ao recarregar a página.'" container="body">
              <span class="activity-status-dot"></span>
              <span class="activity-status-text">
                @switch (activity.status()) {
                  @case ('on') { Ao vivo }
                  @case ('connecting') { Conectando… }
                  @case ('reconnecting') { Reconectando… }
                  @default { Sem tempo real }
                }
              </span>
            </span>
          </div>
          <div class="activity-list">
            @for (group of activityGroups(); track group.companyId) {
              <!-- Cabeçalho só quando há alerta de mais de uma empresa: a ativa primeiro. -->
              @if (activityGroups().length > 1) {
                <button type="button" class="activity-group" [class.activity-group--current]="group.current"
                  [attr.aria-expanded]="isGroupOpen(group)" (click)="toggleGroup(group, $event)">
                  <i class="ti activity-group-chevron" [ngClass]="isGroupOpen(group) ? 'ti-chevron-down' : 'ti-chevron-right'"></i>
                  @if (companyIcon(group.companyId); as icon) {
                    <app-avatar class="activity-group-icon" size="avatar-xs" [nome]="group.name" [url]="icon"></app-avatar>
                  } @else {
                    <i class="ti ti-building-store"></i>
                  }
                  <span class="activity-group-name">{{ group.name || ('Empresa #' + group.companyId) }}</span>
                  @if (group.current) {
                    <span class="activity-group-tag">atual</span>
                  }
                  <span class="activity-group-count">{{ group.events.length }}</span>
                </button>
              }
            @if (activityGroups().length === 1 || isGroupOpen(group)) {
            @for (event of group.events; track event.type + (event.link || event.occurredAt)) {
              <button type="button" class="activity-item" (click)="openActivity(event)">
                <span class="activity-ic activity-ic--danger">
                  <i [ngClass]="activityIcon(event.type)"></i>
                </span>
                <span class="activity-text">
                  <span class="activity-title">{{ event.title }}</span>
                  @if (event.detail) {
                    <span class="activity-detail">{{ event.detail }}</span>
                  }
                  <span class="activity-action">{{ activityAction(event) }}</span>
                </span>
                <span class="activity-time">{{ event.occurredAt | date: 'HH:mm' }}</span>
              </button>
            }
            }
            } @empty {
              <div class="text-center py-4 px-3">
                <i class="ti ti-circle-check d-block mb-2 text-success" style="font-size: 1.8rem; opacity: 0.7"></i>
                <span class="small fw-medium text-heading d-block">Nenhuma falha de integração.</span>
                <span class="small text-muted">Pedidos, notas fiscais e liquidações recusados pelo ERP aparecem aqui.</span>
              </div>
            }
          </div>
          @if (activity.events().length > 0) {
            <div class="activity-foot border-top">
              <button type="button" class="btn btn-sm btn-text-secondary w-100" (click)="activity.clear()">
                <i class="ti ti-eraser me-1"></i>Limpar alertas
              </button>
            </div>
          }
        </div>
      </li>

      <!-- Ajuda: tour de boas-vindas, tutoriais por módulo (modal) e Central de Ajuda.
           NÃO usar container="body" aqui: o posicionamento do ngb briga com o CSS do tema e o
           menu some. O conflito de empilhamento (página por cima do menu) é resolvido no
           styles.scss elevando o z-index da navbar enquanto houver dropdown aberto (:has). -->
      <li class="nav-item navbar-dropdown dropdown mx-1 mx-sm-2" ngbDropdown>
        <a id="navbar-help" class="nav-link hide-arrow p-0" href="javascript:void(0);" ngbDropdownToggle
          aria-label="Ajuda e tutoriais">
          <i class="ti ti-help-circle fs-large cursor-pointer text-muted"></i>
        </a>
        <ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <li>
            <button class="dropdown-item" (click)="startGeneralTour()" ngbDropdownItem>
              <i class="ti ti-confetti ti-sm me-2"></i>
              <span class="align-middle">Tour de boas-vindas</span>
            </button>
          </li>
          <li>
            <button class="dropdown-item" (click)="openToursModal()" ngbDropdownItem>
              <i class="ti ti-route ti-sm me-2"></i>
              <span class="align-middle">Tutoriais</span>
            </button>
          </li>
          <li>
            <button class="dropdown-item" (click)="toggleShortcutsModal()" ngbDropdownItem>
              <i class="ti ti-keyboard ti-sm me-2"></i>
              <span class="align-middle">Atalhos de teclado</span>
            </button>
          </li>
          <li><div class="dropdown-divider my-1"></div></li>
          <li>
            <a class="dropdown-item" href="https://sisand.movidesk.com/kb/" target="_blank" ngbDropdownItem>
              <i class="ti ti-lifebuoy ti-sm me-2"></i>
              <span class="align-middle">Central de ajuda</span>
            </a>
          </li>
        </ul>
      </li>

      <!-- User dropdown -->
      <li class="nav-item navbar-dropdown dropdown-user dropdown" ngbDropdown>
        <a class="nav-link dropdown-toggle hide-arrow p-0" href="javascript:void(0);" ngbDropdownToggle>
          <app-avatar size="avatar-sm" [circle]="true" [nome]="nomeUsuario" [url]="avatarUsuario" [scaleGray]="true"
            status="online">
          </app-avatar>
        </a>
        <ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <li>
            <a class="dropdown-item mt-0" href="javascript:void(0);">
              <div class="d-flex align-items-center">
                <div class="flex-shrink-0 me-2">
                  <app-avatar size="avatar-md" [circle]="true" [nome]="nomeUsuario" [url]="avatarUsuario"
                    [scaleGray]="true" status="online">
                  </app-avatar>
                </div>
                <div class="flex-grow-1">
                  <h6 class="mb-0">{{ nomeUsuario }}</h6>
                  <small class="text-muted">Usuário</small>
                </div>
              </div>
            </a>
          </li>
          <li>
            <div class="dropdown-divider my-1"></div>
          </li>
          <li>
            <button class="dropdown-item" [routerLink]="['/usuario']" ngbDropdownItem>
              <i class="ti ti-user-check ti-sm me-2"></i>
              <span class="align-middle">Meu perfil</span>
            </button>
          </li>
          <li>
            <button class="dropdown-item" (click)="openPreferences(preferencesModal)" ngbDropdownItem>
              <i class="ti ti-adjustments-horizontal ti-sm me-2"></i>
              <span class="align-middle">Preferências</span>
            </button>
          </li>
          <li>
            <div class="dropdown-divider my-1"></div>
          </li>
          <li>
            <button class="dropdown-item" (click)="sair()" ngbDropdownItem>
              <i class="ti ti-logout ti-sm me-2"></i>
              <span class="align-middle">Sair</span>
            </button>
          </li>
        </ul>
      </li>
      <!-- End user dropdown -->

    </ul>
  </div>
</nav>

<!-- Search modal -->
<app-navbar-search />

<!-- Preferências de exibição: valem em TODAS as telas (não é config por grid) e ficam no
     navegador, porque descrevem o conforto visual da máquina em uso. -->
<ng-template #preferencesModal let-modal>
  <div class="modal-header border-0 pb-0">
    <div>
      <h5 class="modal-title mb-1">Preferências</h5>
      <p class="text-muted small mb-0">Ajuste a exibição das listagens neste navegador.</p>
    </div>
    <button type="button" class="btn-close" aria-label="Fechar" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body pt-3">
    <fieldset>
      <legend class="form-label mb-1">Densidade das listagens</legend>
      <p class="text-muted small mb-2">
        A densidade compacta mostra mais linhas por tela.
      </p>
      <div class="btn-group w-100" role="group" aria-label="Densidade das listagens">
        @for (option of densityOptions; track option.value) {
          <button type="button" class="btn"
            [class.btn-primary]="preferences.density() === option.value"
            [class.btn-label-secondary]="preferences.density() !== option.value"
            [attr.aria-pressed]="preferences.density() === option.value"
            (click)="preferences.setDensity(option.value)">
            <i class="ti me-1" [ngClass]="option.icon"></i> {{ option.label }}
          </button>
        }
      </div>
    </fieldset>
    <fieldset class="mt-4">
      <legend class="form-label mb-1">Itens por página</legend>
      <p class="text-muted small mb-2">
        Padrão para todas as listagens. A escolha feita no rodapé de uma listagem vale só para ela.
      </p>
      <div class="btn-group w-100" role="group" aria-label="Itens por página">
        @for (size of preferences.pageSizeOptions; track size) {
          <button type="button" class="btn"
            [class.btn-primary]="preferences.pageSize() === size"
            [class.btn-label-secondary]="preferences.pageSize() !== size"
            [attr.aria-pressed]="preferences.pageSize() === size"
            (click)="preferences.setPageSize(size)">
            {{ size }}
          </button>
        }
      </div>
    </fieldset>
  </div>
  <div class="modal-footer border-0 pt-0">
    <button type="button" class="btn btn-label-secondary" (click)="modal.close()">Fechar</button>
  </div>
</ng-template>

<!-- Atalhos de teclado: abre pelo menu de ajuda ou pela tecla "?" fora de campos de texto. -->
<ng-template #shortcutsModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="modal-title">Atalhos de teclado</h5>
    <button type="button" class="btn-close" aria-label="Fechar" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body pt-3">
    <ul class="list-unstyled d-grid gap-3 mb-0">
      <li class="d-flex justify-content-between align-items-center gap-3">
        <span>Buscar páginas, ações, produtos, pedidos e notas fiscais</span>
        <span class="text-nowrap"><kbd>Ctrl</kbd> + <kbd>K</kbd></span>
      </li>
      <li class="d-flex justify-content-between align-items-center gap-3">
        <span>Navegar pelos resultados da busca</span>
        <span class="text-nowrap"><kbd>↑</kbd> <kbd>↓</kbd></span>
      </li>
      <li class="d-flex justify-content-between align-items-center gap-3">
        <span>Abrir o item selecionado</span>
        <span class="text-nowrap"><kbd>Enter</kbd></span>
      </li>
      <li class="d-flex justify-content-between align-items-center gap-3">
        <span>Fechar busca e janelas</span>
        <span class="text-nowrap"><kbd>Esc</kbd></span>
      </li>
      <li class="d-flex justify-content-between align-items-center gap-3">
        <span>Mostrar esta lista</span>
        <span class="text-nowrap"><kbd>?</kbd></span>
      </li>
    </ul>
  </div>
</ng-template>